import { GoogleStorageVideo } from './GoogleStorageVideo'
import { Spinner } from './Spinner'
import { Dialog, InlineDialog } from './dialogs/Dialog'
import { DialogCloseButton } from './dialogs/DialogCloseButton'
import { useTranslationTyped } from 'i18n/i18n'

export function VideoPreviewDialog({
  src,
  inline = false,
  onDismiss,
  requiresAuthHeaders = false,
  skipCache = false,
  alt,
}: {
  src: string
  inline?: boolean
  onDismiss?: () => void
  requiresAuthHeaders?: boolean
  skipCache?: boolean
  alt: string
}) {
  const { tt } = useTranslationTyped()
  const DialogToUse = inline ? InlineDialog : Dialog
  // derive captions URL by swapping .mp4/.webm with .vtt while preserving query string if present
  const vttSrc =
    src && /\.(mp4|webm)(?=(\?|$))/i.test(src)
      ? src.replace(/\.(mp4|webm)(?=(\?|$))/i, '.vtt')
      : undefined

  return (
    <DialogToUse
      onDismiss={onDismiss}
      size="custom"
      className="relative flex aspect-video max-h-[90vh] w-[90vw] flex-col overflow-hidden rounded-2xl bg-surface !p-0"
      innerClassName="!p-0 overflow-hidden flex flex-col items-center h-full "
      aria-labelledby={undefined}
      aria-label={tt.videos_preview.video_preview()}
    >
      <DialogCloseButton
        className="z-[50]"
        onClick={() => {
          if (onDismiss) onDismiss()
          // returning true pops dialog
          return !inline
        }}
      />
      <div className="aspect-video h-full w-full overflow-hidden">
        {!requiresAuthHeaders ? (
          <video
            autoPlay
            className="!aspect-video max-h-full w-full max-w-full rounded-2xl"
            controls
            crossOrigin="anonymous"
            src={src}
          >
            {vttSrc && (
              <track
                kind="subtitles"
                srcLang="en"
                label={tt.videos_preview.english()}
                src={vttSrc}
              />
            )}
          </video>
        ) : (
          <GoogleStorageVideo
            namespace="preview-dialog"
            skipCache={skipCache}
            autoPlay
            className="!aspect-video max-h-full w-full max-w-full rounded-2xl"
            controls
            crossOrigin="anonymous"
            src={src}
            alt={alt}
            loader={
              <div className="flex aspect-video min-w-[300px] items-center justify-center sm:min-w-[400px] md:min-w-[600px]">
                <div>
                  <div className="mb-2 text-label-medium">
                    {tt.videos_preview.loading_video()}
                  </div>
                  <div className="flex justify-center">
                    <Spinner />
                  </div>
                </div>
              </div>
            }
          >
            {vttSrc && (
              <track
                kind="subtitles"
                srcLang="en"
                label={tt.videos_preview.english()}
                src={vttSrc}
              />
            )}
          </GoogleStorageVideo>
        )}
      </div>
    </DialogToUse>
  )
}
